export const parseLatLng = (
  value?: string,
): { lat: number; lng: number } | null => {
  if (!value) return null;

  const [lat, lng] = value.split(',').map((item) => Number(item.trim()));

  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;

  return { lat, lng };
};
